"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertBox = void 0;
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const styled_components_1 = __importDefault(require("styled-components"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const StyledBox = styled_components_1.default.span `	

	width: 100%;
	padding: 15px 20px 15px 20px;
  margin-bottom: 30px;
  font-size: $small-font-size;
  color: $text-black;

	background-color: ${({ theme, type }) => {
    if (type === 'info')
        return theme.cornflowerBlue;
    if (type === 'error')
        return theme.lightRed;
}};

	svg {
		color:  ${({ theme, type }) => {
    if (type === 'info')
        return theme.denimBlue;
    if (type === 'error')
        return theme.invalidRed;
}};
	
		margin-right: 15px;
	}
`;
;
const AlertBox = ({ children, type, role }) => {
    const alertIcon = {
        info: pro_solid_svg_icons_1.faCheckCircle,
        error: pro_solid_svg_icons_1.faExclamationTriangle
    };
    return (react_1.default.createElement(StyledBox, { type: type, role: role },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: alertIcon[type] }),
        children));
};
exports.AlertBox = AlertBox;
